import api from '../config/api';
import { API_URLS } from '../config/urls';

export const offerService = {
    getOffers: async () => {
        const response = await api.get(API_URLS.COUPONS);
        return response.data;
    },
};
